<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="Group_2140" data-name="Group 2140" transform="translate(-24023 121)">
    <rect id="Rectangle_173" data-name="Rectangle 173" width="24" height="24" transform="translate(24023 -121)" fill="none"/>
    <g id="arrow-left" transform="translate(24023 -121)">
      <line id="Line_84" data-name="Line 84" x1="14" transform="translate(5 12)" fill="none" stroke="#44454d" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <path id="Path_1232" data-name="Path 1232" d="M12,19,5,12l7-7" fill="none" stroke="#44454d" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    </g>
  </g>
</svg>
